import { createSlice } from '@reduxjs/toolkit'

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { isDefined } from '../../utils'

const initialState = {
  fursuit: {
    campaigns: [],
    fursuits: []
  },
  checksum: undefined,
  updated: undefined,
  error: undefined
}

const dataMapper = {
  fursuit: (campaigns, entities) => {
    const votes = new Map()
    let deadline
    let deadlineMs
    let votingStart
    let votingStartMs
    campaigns.forEach((campaign) => {
      const campaignDeadlineMs = isDefined(campaign.deadline) ? Date.parse(campaign.deadline) : undefined
      if (isDefined(campaignDeadlineMs)) {
        const campaignDeadline = Math.max(0, Math.floor((campaignDeadlineMs - Date.now()) / 1000))
        deadline = isDefined(deadline) ? Math.min(deadline, campaignDeadline) : campaignDeadline
        deadlineMs = isDefined(deadlineMs) ? Math.min(deadlineMs, campaignDeadlineMs) : campaignDeadlineMs
      }
      const campaignVotingStartMs = isDefined(campaign.voting_start) ? Date.parse(campaign.voting_start) : undefined
      if (isDefined(campaignVotingStartMs)) {
        const campaignVotingStart = Math.max(0, Math.floor((campaignVotingStartMs - Date.now()) / 1000))
        votingStart = isDefined(votingStart) ? Math.max(votingStart, campaignVotingStart) : campaignVotingStart
        votingStartMs = isDefined(votingStartMs) ? Math.max(votingStartMs, campaignVotingStartMs) : campaignVotingStartMs
      }
      const campaignVotes = campaign.votes ?? []
      campaignVotes.forEach((vote) => {
        const id = parseInt(vote.entity_id)
        const voted = votes.get(id) ?? []
        voted.push(campaign.name)
        votes.set(parseInt(id), voted)
      })
    })
    return {
      campaigns: campaigns ?? [],
      fursuits: entities ?? [],
      votedUsers: Array.from(votes.keys()),
      votes: Object.fromEntries(votes),
      deadline,
      deadlineMs,
      votingStart,
      votingStartMs
    }
  },
  snacks_exchange: (campaigns, entities) => {
    const votes = new Map()
    let deadline
    let votingStart
    let deadlineMs
    let votingStartMs
    campaigns.forEach((campaign) => {
      const campaignDeadlineMs = isDefined(campaign.deadline) ? Date.parse(campaign.deadline) : undefined
      if (isDefined(campaignDeadlineMs)) {
        const campaignDeadline = Math.max(0, Math.floor((campaignDeadlineMs - Date.now()) / 1000))
        deadline = isDefined(deadline) ? Math.min(deadline, campaignDeadline) : campaignDeadline
        deadlineMs = isDefined(deadlineMs) ? Math.min(deadlineMs, campaignDeadlineMs) : campaignDeadlineMs
      }
      const campaignVotingStartMs = isDefined(campaign.voting_start) ? Date.parse(campaign.voting_start) : undefined
      if (isDefined(campaignVotingStartMs)) {
        const campaignVotingStart = Math.max(0, Math.floor((campaignVotingStartMs - Date.now()) / 1000))
        votingStart = isDefined(votingStart) ? Math.max(votingStart, campaignVotingStart) : campaignVotingStart
        votingStartMs = isDefined(votingStartMs) ? Math.max(votingStartMs, campaignVotingStartMs) : campaignVotingStartMs
      }
      const campaignVotes = campaign.votes ?? []
      campaignVotes.forEach((vote) => {
        const id = parseInt(vote.entity_id)
        const voted = votes.get(id) ?? []
        voted.push(campaign.name)
        votes.set(id, voted)
      })
    })
    return {
      campaigns: campaigns ?? [],
      entities: entities ?? [],
      votes: Object.fromEntries(votes),
      deadline,
      votingStart,
      deadlineMs,
      votingStartMs
    }
  },
  default: (campaigns, entities) => {
    return {
      campaigns,
      entities
    }
  }
}

const voting = createSlice({
  name: 'voting',
  initialState,
  reducers: {
    fetchUserVotingCategorySuccess (state, action) {
      const { data, checksum, generated } = action.payload
      const categories = {}
      for (const category of data) {
        const { name, campaigns, entities } = category
        const mapper = dataMapper[name] ?? dataMapper.default
        categories[name] = mapper(campaigns, entities)
      }
      return {
        ...state,
        ...categories,
        checksum,
        generated
      }
    },
    fetchUserVotingCategoryError (state, action) {
      const { detail } = action.payload

      return {
        ...state,
        error: detail
      }
    }
  }
})

const persistConfig = {
  key: 'voting',
  storage
}

export const { fetchUserVotingCategorySuccess, fetchUserVotingCategoryError } = voting.actions
export const VotingReducer = persistReducer(persistConfig, voting.reducer)
